module.exports = __webpack_public_path__ + "static/Underdown1-44ac06257de6a83d37eca368aa4be900.webp";